import { SafePromise } from '@benzinga/safe-await';

import { RestfulClient } from '@benzinga/session';
// import { EgressMovers } from './egress';
import { MoversResponse, MoversQuery } from './entities';
// import { IncomingMoversResult } from './ingest';
import { Session } from '@benzinga/session';
import { MoversEnvironment } from './environment';

export class MoversRestful extends RestfulClient {
  constructor(session: Session) {
    super(
      session.getEnvironment(MoversEnvironment).url,
      session,
      { 'x-device-key': false },
      {
        tokenParameterName: 'apikey',
      },
    );
  }

  getMovers = (query: MoversQuery): SafePromise<MoversResponse> => {
    const params: MoversQuery = Object.assign(query);
    if (query.screenerQuery && typeof query.screenerQuery === 'object') {
      params.screenerQuery = this.buildScreenerQuery(
        query?.screenerQuery as Record<string, string | number | boolean | (number | string | boolean)[]>,
      );
    }
    if (query.moversQuery && typeof query.moversQuery === 'object') {
      params.moversQuery = this.buildScreenerQuery(
        query?.moversQuery as Record<string, string | number | boolean | (number | string | boolean)[]>,
      );
    }
    params['apikey'] = this.session.getEnvironment(MoversEnvironment).key;
    const url = this.URL('movers', params);
    return this.get(url, {
      allowsAnonymousAuth: true,
      credentials: 'same-origin',
      includeHeader: { authorizationSession: true },
    });
  };

  buildScreenerQuery(
    screenerQuery: Record<string, number | string | boolean | (number | string | boolean)[]>,
  ): string | undefined {
    const screenerQueryParams = Object.keys(screenerQuery)
      .filter(key => screenerQuery[key])
      .map((key: string) => {
        const val = screenerQuery[key];
        const value = Array.isArray(val) ? (val as (number | string | boolean)[]).join(',') : val;
        return `${key}_${value}`;
      });
    return screenerQueryParams.join(';') || undefined;
  }
}
